/**
 * state
 */
const state = {
  visible: false,
  isInCart: false,
  subInCart: false,
};

/**
 * getters
 */
const getters = {};

/**
 * mutations
 */
const mutations = {
  TOGGLE(state) {
    state.visible = !state.visible;
  },

  SHOW(state) {
    state.visible = true;
  },

  HIDE(state) {
    state.visible = false;
  },

  IS_IN_CART(state, payload) {
    state.isInCart = payload;
  },

  SUB_IN_CART(state, payload) {
    state.subInCart = payload;
  },
};

/**
 * actions
 */
const actions = {
  toggle({ commit }) {
    commit("TOGGLE");
  },

  show({ commit, state }) {
    if (state.isInCart) return;
    const isInCart = window.localStorage.getItem("gwpAdded");
    if (isInCart !== "yes") {
      commit("SHOW");
      commit("IS_IN_CART", false);
    } else {
      commit("IS_IN_CART", true);
    }
  },

  hide({ commit }) {
    commit("HIDE");
  },

  setIsInCart({ commit }, payload) {
    if (payload) {
      window.localStorage.setItem("gwpAdded", "yes");
    } else {
      window.localStorage.removeItem("gwpAdded");
    }
    commit("IS_IN_CART", payload);
  },

  setSubInCart({ commit }, payload) {
    commit("SUB_IN_CART", payload);
  },

  async addToCart({ commit, dispatch }, payload) {
    // Set GWP state BEFORE addItem so that the gwp-progress-bar watcher
    // (triggered by cartData change inside addItem) finds localStorage
    // already set and doesn't re-show the GWP line item.
    commit("HIDE");
    window.localStorage.setItem("gwpAdded", "yes");
    commit("IS_IN_CART", true);

    try {
      await dispatch(
        "cart/addItem",
        {
          id: payload.id,
          quantity: 1,
          properties: { _gwp: true },
          // What the row shows until Shopify answers; rendered by
          // `helper-optimistic-json.liquid` next to the gift itself.
          _optimistic: payload.line,
        },
        { root: true }
      );

      if (payload.discountCode && window.$) {
        window.$.ajax({
          type: "GET",
          url: `/discount/${payload.discountCode}`,
        });
      }
    } catch (error) {
      console.error("GWP add to cart error:", error);
    }
  },
};

/**
 * export
 */
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
